import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareU = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler24') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler24', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Skilling pet!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Skilling pet!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareU}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareU
  
